import './assets/styles/common.scss'
import components from './components'
import RouteMeta from './model/RouteMeta'
import Mobile, {mobileConfig} from './model/Mobile'
import Code from './model/Code'
import Api from './model/Api'
import BaseUser from './model/BaseUser'
import TabbarItem from './model/TabbarItem'
import {Picker} from './model/Dialog'
import DatePicker from './model/DatePicker'
import {RouteEffectTypes, AuthTypes, PopupDir} from './enum'
import {ActionSheetButton} from './model/Dialog'
import utils from './utils'

import BuryService from './services/BuryService'

import Require from './model/require/Require'
import {CheckTypes} from './model/require/enums'

const enums = {
	RouteEffectTypes,
	AuthTypes,
	PopupDir,
	CheckTypes
}

const model = {
	ActionSheetButton,
	Api,
	BaseUser,
	Code,
	DatePicker,
	Picker,
	TabbarItem
}

export default {
	Mobile,
	...components
}

export {
	RouteMeta,
	mobileConfig,
	enums,
	model,
	utils,
	Require,
	
	BuryService
}